import calendar from './calendar.png';
import gnbChart from './gnb-chart.png';
import gnbDealer from './gnb-dealer.png';
import arrowDown from './arrow-down.svg';
import noImage from './noimage.png';

export interface Images {
  calendar: any;
  gnbChart: any;
  gnbDealer: any;
  arrowDown: any;
  noImage: any;
}

const images: Images = {
  calendar,
  gnbChart,
  gnbDealer,
  arrowDown,
  noImage
};

export default images;
